import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api, { formatError } from "@/api";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";
import { ArrowLeft, ShieldCheck } from "lucide-react";
import { toast } from "sonner";

export default function SuperAdminLogin() {
  const navigate = useNavigate();
  const { setSession } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const { data } = await api.post("/auth/superadmin/login", { email, password });
      setSession(data);
      toast.success("Welcome, Platform Owner");
      navigate("/superadmin");
    } catch (err) {
      toast.error(formatError(err.response?.data?.detail) || err.message);
    } finally { setSubmitting(false); }
  };

  return (
    <div className="min-h-screen bg-slate-900 text-white flex flex-col" data-testid="superadmin-login-page">
      <header className="px-6 md:px-12 py-6">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-slate-300 hover:text-white">
          <ArrowLeft className="w-4 h-4" /> Back
        </Link>
      </header>
      <main className="flex-1 flex items-center justify-center px-6 pb-16">
        <Card className="w-full max-w-md p-8 bg-slate-800 border-slate-700 text-white">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-sky-500 to-emerald-500 flex items-center justify-center">
              <ShieldCheck className="w-5 h-5" />
            </div>
            <div>
              <h1 className="font-heading text-2xl font-semibold">Super Admin</h1>
              <p className="text-xs text-slate-400">Platform-owner dashboard</p>
            </div>
          </div>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label className="text-slate-200">Email</Label>
              <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="sa-email" className="bg-slate-900 border-slate-700 text-white" />
            </div>
            <div>
              <Label className="text-slate-200">Password</Label>
              <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="sa-password" className="bg-slate-900 border-slate-700 text-white" />
            </div>
            <Button type="submit" disabled={submitting} className="w-full bg-gradient-to-r from-sky-500 to-emerald-500 hover:opacity-90 text-white" data-testid="sa-submit">
              {submitting ? "Signing in..." : "Sign In"}
            </Button>
          </form>
        </Card>
      </main>
    </div>
  );
}
